import { Link } from "react-router-dom";

function NotFound() {
  return (
    <main className="flex-grow mx-auto max-w-7xl w-full flex flex-col px-4 sm:px-6 lg:px-8">
        <div className="flex-shrink-0 my-auto py-16 sm:py-32">
          <p className="text-sm font-semibold text-white uppercase tracking-wide">404 error</p>
          <h1 className="mt-2 text-4xl font-extrabold text-white tracking-tight sm:text-5xl">Page not found</h1>
          <p className="mt-2 text-base text-white">Sorry, we couldn’t find the page you’re looking for.</p>
          <div className="mt-6">
            <Link to="/">
              <a className="text-base font-medium text-white">
                Go back home<span aria-hidden="true"> &rarr;</span>
              </a>
            </Link>
          </div>
        </div>
      </main>
  );
}

export default NotFound;